import { t } from 'i18next';
import * as yup from 'yup';

import { AddressFields } from 'addresses/enums';
import { addressSchema } from 'addresses/schemas';
import { ICompanySettings } from 'auth/types';
import { testRequiredSchema } from 'core/schemas';
import { getEmptyErrorMessage, numberSchemaWithTransform } from 'core/yup';

const requiredFieldsSettings: ICompanySettings = {
  projectCloseConfidenceRequired: 0,
  projectEstimatedCloseDateRequired: 0,
  projectEstimatedValueRequired: 0,
  verticalMarketRequired: 0,
};

export const addProjectSchema = (companySettings = requiredFieldsSettings) =>
  yup.object().shape({
    name: yup
      .string()
      .nullable()
      .required(getEmptyErrorMessage(t('labelName'))),
    address: addressSchema(false, [AddressFields.COUNTRY]),
    estimatedValue: numberSchemaWithTransform()
      .label(t('labelEstimatedValue'))
      .nullable()
      .test(
        ...testRequiredSchema(
          Boolean(companySettings.projectEstimatedValueRequired),
          t('labelEstimatedValue')
        )
      ),
    closeConfidence: numberSchemaWithTransform()
      .label(t('labelCloseConfidence'))
      .nullable()
      .min(0, t('errorCloseConfidenceOutOfBounds'))
      .max(100, t('errorCloseConfidenceOutOfBounds'))
      .test(
        ...testRequiredSchema(
          Boolean(companySettings.projectCloseConfidenceRequired),
          t('labelCloseConfidence')
        )
      ),
    closeDate: yup
      .string()
      .label(t('labelCloseDate'))
      .nullable()
      .test(
        ...testRequiredSchema(
          Boolean(companySettings.projectEstimatedCloseDateRequired),
          t('labelCloseDate')
        )
      ),
    verticalMarket: yup
      .object()
      .label(t('labelVerticalMarket'))
      .nullable()
      .test(
        ...testRequiredSchema(
          Boolean(companySettings.verticalMarketRequired),
          t('labelVerticalMarket')
        )
      ),
    competitors: yup.string().nullable(),
    validSince: yup.string().nullable(),
    validUntil: yup.string().nullable(),
  });
